const styles = {
    deleteContactModalContent: {
        height: 'fit-content',
        width: 'fit-content',
        margin: 'auto',
        fontFamily: 'DM Sans',
        borderRadius: '20px'
    },
}

export default styles